export const ABSOLUTE = 'ABSOLUTE';
export const INCREMENTAL = 'INCREMENTAL';
export const ABSOLUTE_ARC = 'ABSOLUTE_ARC';
export const INCREMENTAL_ARC = 'INCREMENTAL_ARC';
